import { useTranslation } from '@flecto/translations'
import { type CoreItemPricingTier } from '@flecto/types'
import { useCurrencyUtils } from '@flecto/utils'

export type UseItemPricingTierLabelPayload = {
  tiers?: CoreItemPricingTier[]
  itemTier?: CoreItemPricingTier
  withPrice?: boolean
  withFormatPrice?: boolean
  withTax?: boolean
}

export function usePricingTierLabel({
  tiers = [],
  itemTier,
  withPrice = false,
  withFormatPrice = false,
  withTax = false,
}: UseItemPricingTierLabelPayload): string | null {
  const { centsToCurrency } = useCurrencyUtils()
  const pricingTierLength = tiers?.length

  if (!pricingTierLength && !itemTier) {
    return null
  }

  let unit = ''

  const pricingTier = itemTier
    ? itemTier
    : pricingTierLength === 1
      ? tiers[0]
      : tiers.filter((r) => r.selected === true)[0] ||
        tiers.find((r) => r.suggested === true)

  if (pricingTier?.duration_value === 1) {
    switch (pricingTier.duration_unit) {
      case 'days':
        unit = 'day'
        break
      case 'hours':
        unit = 'hour'
        break
      default:
        break
    }
  } else {
    unit = pricingTier?.duration_unit ?? ''
  }
  const priceCents = withTax
    ? pricingTier?.price_with_vat_cents
    : pricingTier?.price_cents

  const price = ((priceCents) => {
    if (withFormatPrice) {
      return priceCents !== undefined && `${centsToCurrency(priceCents, true)} `
    }
    if (withPrice) {
      return priceCents && `${priceCents} `
    }
    return ''
  })(priceCents)

  const label =
    pricingTier?.type === 'custom'
      ? pricingTier.label === ''
        ? ''
        : `(${pricingTier.label})`
      : pricingTier?.label || pricingTier?.duration_value
        ? `(${pricingTier?.label || `${pricingTier?.duration_value} ${unit}`})`
        : ''

  return `${price}${label}`
}

export function translateLabelFormated(label: string) {
  const { t: tItems } = useTranslation('saas', { keyPrefix: 'items' })
  const regex = /([€$£]\s*\d+[.,]?\d*)\s*\((\d+)\s*(day|days|hour|hours)\)/

  const match = label.match(regex)

  if (match) {
    const [, price, value, unit] = match

    const translatedUnit = tItems(`overtime_charge.${unit}`)

    return `${price} (${value} ${translatedUnit})`
  }
  return label
}
